import { cn } from "@/lib/utils";

/** The Apple logo, for the App Store button and the iPhone in the drawings. */
export const AppleGlyph = ({ className }: { className?: string }) => (
  <svg aria-hidden viewBox="0 0 24 24" fill="currentColor" className={cn("size-[22px]", className)}>
    <path d="M16.4 12.6c0-2.4 2-3.6 2.1-3.7-1.2-1.7-3-1.9-3.6-2-1.5-.2-3 .9-3.8.9-.8 0-2-.9-3.3-.9-1.7 0-3.3 1-4.2 2.6-1.8 3.1-.5 7.7 1.3 10.2.9 1.2 1.9 2.6 3.2 2.6 1.3-.1 1.8-.8 3.3-.8 1.6 0 2 .8 3.4.8 1.4 0 2.3-1.3 3.1-2.5 1-1.4 1.4-2.8 1.4-2.9-.1 0-2.8-1-2.9-4.3zM13.9 5.4c.7-.8 1.2-2 1-3.1-1 0-2.2.7-2.9 1.5-.6.7-1.2 1.9-1 3 1.1.1 2.2-.6 2.9-1.4z" />
  </svg>
);

/** The Google Play triangle, for the store button. */
export const PlayGlyph = ({ className }: { className?: string }) => (
  <svg aria-hidden viewBox="0 0 24 24" fill="currentColor" className={cn("size-5", className)}>
    <path d="M4.2 2.5c-.3.3-.4.7-.4 1.2v16.6c0 .5.1.9.4 1.2l.1.1 9.3-9.3v-.2L4.3 2.4l-.1.1zm12.5 12.9-3.1-3.1v-.2l3.1-3.1.1.1 3.7 2.1c1 .6 1 1.6 0 2.2l-3.7 2.1-.1-.1zm-.1.1-3.2-3.2-9.4 9.4c.4.4.9.4 1.6.1l11-6.3m0-6.5-11-6.3c-.7-.4-1.2-.3-1.6.1l9.4 9.4 3.2-3.2z" />
  </svg>
);

/** The Android robot's head, for the Android phone in the drawings. */
export const AndroidGlyph = ({ className }: { className?: string }) => (
  <svg aria-hidden viewBox="0 0 24 24" fill="currentColor" className={cn("size-[22px]", className)}>
    <path d="M17.6 9.48l1.84-3.18a.38.38 0 0 0-.66-.38l-1.86 3.22a11.4 11.4 0 0 0-9.84 0L5.22 5.92a.38.38 0 0 0-.66.38L6.4 9.48A10.78 10.78 0 0 0 1 18h22a10.78 10.78 0 0 0-5.4-8.52zM7 15.25A1.25 1.25 0 1 1 8.25 14 1.25 1.25 0 0 1 7 15.25zm10 0A1.25 1.25 0 1 1 18.25 14 1.25 1.25 0 0 1 17 15.25z" />
  </svg>
);
